import React from 'react'
import PropTypes from 'prop-types'

// Models
import Payment from 'models/Payment'

// Components
import ButtonDownload from 'ui/ButtonDownload'

// Api
import { downloadPayment } from 'api/payment'

// Services
import message from 'services/message'

// Helpers
import { resolveErrorMessage } from 'helpers'

export default function ColumnAction({ row, downloadDisabled, setLoading }) {
  const onDownloadPaymentBreakdownClick = async (typeFile) => {
    try {
      setLoading(true)
      return await downloadPayment({
        paymentId: row.id,
        paymentMethod: row.paymentMethod,
        typeFile,
      })
    } catch (error) {
      message.error(await resolveErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="t-actions">
      <div className="p-1" />
      <ButtonDownload
        underline
        variant="link"
        extentions={['xlsx', 'csv']}
        disabled={downloadDisabled}
        onClick={(type) => onDownloadPaymentBreakdownClick(type)}
      >
        Download
      </ButtonDownload>
    </div>
  )
}

ColumnAction.propTypes = {
  row: PropTypes.instanceOf(Payment),
  vendorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  companyCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  contractNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  downloadDisabled: PropTypes.bool,
  setLoading: PropTypes.func,
}

ColumnAction.defaultProps = {
  row: new Payment(),
  vendorCode: '',
  companyCode: '',
  contractNumber: '',
  downloadDisabled: false,
  setLoading: () => {},
}
